import { ContextMenu, Text } from "@bem-lib/designsystem";
import {
  Container,
  Grid,
  Icon,
  Provider,
  Tooltip,
  useMediaQuery,
} from "@bem-lib/designsystem_old";
import { useEffect, useState } from "react";
// @ts-ignore
import { authSubject, usePermissions } from "@bsp/auth";

import LogoBanrisulMin from "../assets/logo-banrisul-min.svg";
import LogoBanrisul from "../assets/logo-banrisul.svg";
import { TContextMenuItem } from "@bem-lib/designsystem/build/stories/components/context-menu/context-menu.type";
import { navigateToUrl } from "single-spa";
import { sm, xs } from "../utils/breakpointsTheme";
import Menu from "./Menu";
import { DadosUsuario } from "./styles";

const HeaderKeycloak = () => {
  const [nome, setNome] = useState("");
  const [keycloak, setKeycloak] = useState(null);
  const matchSM = useMediaQuery(sm);
  const matchXS = useMediaQuery(xs);
  const { hasPermission } = usePermissions();

  const handleLogout = async () => {
    await keycloak?.logout();
  };

  const itemContextConfiguracao: TContextMenuItem[] = hasPermission(
    "Administrador"
  )
    ? [
        {
          children: "Configurações",
          onClick: () => navigateToUrl("/configuracoes"),
        },
      ]
    : [];

  const itemsContext: TContextMenuItem[] = [
    ...itemContextConfiguracao,
    {
      children: "Usuários",
      onClick: () => navigateToUrl("/usuarios"),
    },
  ];

  useEffect(() => {
    authSubject.subscribe((inscrito) => {
      setNome(inscrito?.username);
      setKeycloak(inscrito?.keycloak);
    });
  }, []);

  if (!nome) {
    return <div />;
  }

  const LogoHeader = () => {
    return (
      <img
        src={!matchSM ? LogoBanrisul : LogoBanrisulMin}
        alt="Logo da bemsign"
        onClick={() => navigateToUrl("/documento")}
        style={{ cursor: "pointer" }}
      />
    );
  };

  return (
    <Provider>
      <div
        style={{
          borderBottom: "thin solid rgb(221, 221, 221)",
          marginBottom: "25px",
          padding: "10px 0px",
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <LogoHeader />
              {!matchXS && <Menu />}
            </Grid>
            <Grid
              item
              xs={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              {!matchXS ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {hasPermission([
                      "Administrador",
                      "Administrador Grupo",
                    ]) && (
                      <ContextMenu
                        buttonProps={{
                          icon: "Configuracoes",
                          variant: "icon",
                          size: "large",
                        }}
                        color="default"
                        items={itemsContext}
                        style={{ display: "flex" }}
                      />
                    )}
                    {nome && (
                      <>
                        <DadosUsuario>
                          <Text size={14} style={{ marginLeft: "10px" }}>
                            <Tooltip title={nome}>{nome}</Tooltip>
                          </Text>
                        </DadosUsuario>
                      </>
                    )}
                    <Icon
                      name="HomeLogout"
                      onClick={() => handleLogout()}
                      size="20px"
                      style={{ marginLeft: "20px" }}
                      id="logout"
                    />
                  </div>
                </>
              ) : (
                <Menu />
              )}
            </Grid>
          </Grid>
        </Container>
      </div>
    </Provider>
  );
};

export default HeaderKeycloak;

